import { useState } from "react";
import { Download, ChevronDown } from "lucide-react";

export function ExportButton({ resource, testid }) {
  const [open, setOpen] = useState(false);
  const base = `${process.env.REACT_APP_BACKEND_URL}/api/exports/${resource}`;
  const doExport = (fmt) => {
    setOpen(false);
    window.open(`${base}?fmt=${fmt}`, "_blank", "noopener");
  };
  return (
    <div className="relative inline-block">
      <button
        data-testid={testid || `export-${resource}`}
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="inline-flex items-center gap-1.5 rounded-md border border-border/70 px-3 py-2 text-xs font-medium hover:bg-secondary"
      >
        <Download className="h-3.5 w-3.5" /> Export <ChevronDown className="h-3 w-3" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 z-30 w-32 overflow-hidden rounded-md border border-border/70 bg-card shadow-lg">
          <button data-testid={`${testid || `export-${resource}`}-csv`} onMouseDown={() => doExport("csv")}
            className="block w-full px-3 py-2 text-left text-xs hover:bg-secondary">Download CSV</button>
          <button data-testid={`${testid || `export-${resource}`}-xlsx`} onMouseDown={() => doExport("xlsx")}
            className="block w-full px-3 py-2 text-left text-xs hover:bg-secondary">Download XLSX</button>
        </div>
      )}
    </div>
  );
}
